import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TextInput,
  View
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { Formik } from 'formik'
import * as yup from 'yup'
import Toast from 'react-native-toast-message'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { useFormsStore } from '../../../stores/onboarding'
import { useTranslation } from 'react-i18next'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'

const KarnsInformationForm = ({ navigation, route }) => {

  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params
  const { t } = useTranslation()
  const { postKarnsOnline, loading } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  const alschema = yup.object({
    printName: yup.string().required('Please Enter Your Name')
  })

  const intialValues = {
    printName: ''
  }


  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'Uniform And Handbook Form'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, action) => {
            const data = {
              essUserKey: initializestore?.initializeData?.userkey,
              entityId: personalstore.personalData?.entityId,
              EssObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'upload' ? false : true,
              name: values?.printName
            }


            if (mode === 'upload') {
              const response: any = await postKarnsOnline(data)
              if (response?.success === true) {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: t(response?.message),
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
              else {
                await Toast.show({
                  type: 'error',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60
                })
                console.log(values.printName);

              }
            } else {
              navigation.navigate('karnsinformationOnline', {
                values,
                essUserOnBoardingKey,
                essUserOnBoardingFormKey,
                completeOnline: mode === 'upload' ? false : true
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '30%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Print Name*'}
                    </Text>
                  </View>
                  <View style={{ width: '60%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.printName}
                      onChangeText={(text) => {
                        props.handleChange('printName')(text)
                      }}
                    />
                    {props.touched.printName && props.errors.printName && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.printName}
                      </Text>
                    )}
                  </View>
                </View>




              </Card>
              {loading ? (
                <ActivityIndicator />
              ) : (
                <View style={{ margin: 10 }}>
                  <CustomButton
                    text={mode === 'upload' ? t('submitinfo') : t('next')}
                    onPress={props.handleSubmit}
                  />
                </View>
              )}
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>

  )
}

export default KarnsInformationForm
